export default __webpack_public_path__ + "static/media/play-circle.6efd4130.svg";